import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import styles from "./tabBar/TabBar.module.scss"
import {NavLink} from "react-router-dom";
import AppContext from "../../../context/appContext"
import CircleChart from "./tabBar/CircleChart";
import http from "../../../services/api/utilities/http";
import { useParams } from "react-router-dom";

const TabBar = props => {

  const history = useHistory();
  const [removeTab, setRemoveTab] = useState(false);
    const { id } = useParams();
  const context = useContext(AppContext);

  const handleRemoveTab = (id) => {
    if (context.openTabs.length !== 1 && context.openTabs.length !== 0) {
      context.handleRemoveTab(id);
      setRemoveTab(true);
    }
  }

  // axios.interceptors.response.use(response => {
  //   return response;
  // }, error => {
  //   if (error.response.status === 401) {
  //     history.location.pathname && history.location.pathname !== "/" && context.handleCallbackUrl(history.location.pathname)
  //     localStorage.removeItem('token')
  //     localStorage.removeItem('role')
  //     history.push("/")
  //   }
  //   return error;
  // });

  useEffect(() => {
    getTabs()
    if (history.location.pathname !== '/variant-explorer'){
         let uid
        if (context.handleUid().uid) {
            uid = context.handleUid().uid;
        } else {
            uid = localStorage.getItem("mapData") && JSON.parse(localStorage.getItem("mapData"))?.uid;
        }
        getVariantsData(uid)
    }

  }, [])

    useEffect(() => {
        if(history.location.pathname.includes("/share/data_analysis/")){
            getVariantsData(context.handleUid().id)
        }
    }, [context.handleUid().id]);


    const getVariantsData = () => {
        let uid = null;
       if (!uid) return;
        http.get("process_mining/process_discovery/" + uid)
            .then(res => {
                let response = res.data.data;
                let { events, case_count } = response;

                context.handleEvents_cases({ events, cases: case_count });
                context.handleListOfVariants(response.variants);
            })
            .catch(err => {
                console.log(err.response);
            });
    };

  const getTabs = () => {
    let id = context.handleUid().id ? context.handleUid().id : localStorage && localStorage.getItem('mapData') ? JSON.parse(localStorage.getItem('mapData'))?.id : null
    !history.location.pathname.includes("/share/data_analysis") && http.get('process_mining/save_tabs_state/' + id)
        .then(res => {
          const state = res.data.data.tabs_config;
          if (state.openTabs) {
            let openTabs = state.openTabs.map(tab => tab.link === 'process-map' ? {
              id: 1,
              title: "Process Explorer",
              link: 'process-explorer'
            } : tab)
            context.handleAddTab('all', openTabs)
            if (state.activeTab) {
              if (state.activeTab === '/process-map')
                history.push('/process-explorer')
              else
                history.push(state.activeTab)
            } else history.push('/process-explorer')
          } else {
            context.handleAddTab(1, 'Process Explorer', 'process-explorer');
            history.push('/process-explorer')
          }
        })
        .catch(err => {
          console.log(err.response)
        })
  }

  useEffect(() => {
    if (removeTab) {
      setTimeout(() => {
        if (context.openTabs.length === 0) {
          history.push('/process-explorer');
        } else {
          history.push(context.openTabs[0].link);
        }
      }, 100);
      setRemoveTab(false);
    }
  }, [removeTab])

  return (
      <div className={`row ${styles.TabBar}`}>
        <ul>
          {
            context.openTabs.map(item => {
              return (
                  <li key={`${item.id}_${item.title}`}>
                <span>
                  <NavLink key={item.id} activeClassName={styles.isActive} to={item.link}>
                    <span>
                      {item.title}
                      <svg onClick={() => handleRemoveTab(item.id)} width="16" height="16" viewBox="0 0 16 16"
                           fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.59701 6.39661L6.40234 9.59127" stroke="#0A195C" strokeLinecap="round"
                              strokeLinejoin="round"/>
                        <path d="M9.598 9.5932L6.40067 6.3952" stroke="#0A195C" strokeLinecap="round"
                              strokeLinejoin="round"/>
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M10.8897 1.8335H5.11035C3.09635 1.8335 1.83368 3.2595 1.83368 5.2775V10.7228C1.83368 12.7408 3.09035 14.1668 5.11035 14.1668H10.889C12.9097 14.1668 14.167 12.7408 14.167 10.7228V5.2775C14.167 3.2595 12.9097 1.8335 10.8897 1.8335Z"
                              stroke="#0A195C" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                  </NavLink>
                </span>
                  </li>
              )
            })
          }
        </ul>
        <span className={styles.rightTexts}>
        <span className={[styles.notifText, 'd-flex'].join(' ')}>
          <div>
            <div>Events Coverage</div>
            <div>{context.handleCaseCoverageData().covered_events} &nbsp; , &nbsp; {context.handleCaseCoverageData().event_coverage_percentage}</div>
          </div>
          <div>
            <CircleChart coveredPercentage={context.handleCaseCoverageData().event_coverage_percentage} />
          </div>
        </span>
        <span className={[styles.notifText, 'd-flex'].join(' ')}>
          <div>
            <div>Case Coverage</div>
            <div>{context.handleCaseCoverageData().covered_cases} &nbsp; , &nbsp; {context.handleCaseCoverageData().case_coverage_percentage}</div>
          </div>
          <div>
            <CircleChart coveredPercentage={context.handleCaseCoverageData().case_coverage_percentage} />
          </div>
        </span>
        <span className={[styles.notifText, 'd-flex'].join(' ')}>
          <div>
            <div>Variants Count</div>
            <div>{context.handleCaseCoverageData().total_variants}</div>
          </div>
        </span>
        <span className={styles.notifText}>
          <div>Total Cases</div>
          <div>{context.handleCaseCoverageData().total_cases}</div>
        </span>
      </span>
      </div>
  )
};

export default TabBar;
